import { render, staticRenderFns } from "./BaseCountdownPill.vue?vue&type=template&id=6b061946&"
import script from "./BaseCountdownPill.vue?vue&type=script&lang=js&"
export * from "./BaseCountdownPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports